import { AxiosError } from 'axios';
import { AuthErrorResponse } from './model';

export const parseAuthError = (error: unknown): AuthErrorResponse | null => {
  if (error instanceof AxiosError) {
    const errorResponse = error?.response?.data;
    if (errorResponse) {
      return errorResponse as AuthErrorResponse;
    }
  }
  return null;
};
